import { SyncEventType } from '../../enums/syncEventType';
import { PersistenceEvent } from './persistenceEvent';

export class EventAllIssuesMarkedAsRead implements PersistenceEvent {

  public readonly type = SyncEventType.ALL_ISSUES_MARKED_AS_READ;
  public timestamp: string;

  constructor(timestamp: string) {
    this.timestamp = timestamp;
  }

  getPayload(): object {
    return {
      'timestamp': this.timestamp
    };
  }

  static fromPayload(payload: any): EventAllIssuesMarkedAsRead {
    return new EventAllIssuesMarkedAsRead(payload['timestamp']);
  }

}
